module.exports = __webpack_public_path__ + "img/jingxuan02.8c84a087.png";